<template>
  <v-container style="padding: 0; height: 100vh; width: 100vw; display: flex; align-items: center; max-width: 100%; justify-content: center;">
    <iframe src="https://passatempocoquetel.supercomics.co/cataletra"  
            width='100%'
            style="border:0;"
            height='100%'></iframe>
  </v-container>
</template>

<script>


export default {
  name: 'testeCoquetel',
 };
</script>

<style lang='scss'>
</style>
